import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Heading } from '@ucheba/ui/components/Heading/desktop'

const HeadingStyled = styled(Heading)<{ textColor: string }>`
  color: ${({ textColor }) => textColor};
`
const TouchHeadingStyled = styled(Heading)`
  padding-left: 16px;
`

const Block = styled.div`
  display: grid;
  grid-flow: column;
  grid-template-columns: 1fr 1fr;
  gap: ${sv.spacing.large};
`

const ScrollBlock = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: ${sv.spacing.xxsmall};
  padding: 0 16px;
  overflow-x: scroll;
`

const ScrollItem = styled.div`
  width: calc(100vw - ${sv.spacing.small} * 2);
  min-width: calc(100vw - ${sv.spacing.small} * 2);
`

export default { Block, ScrollBlock, ScrollItem, HeadingStyled, TouchHeadingStyled }
